export const DATA_PNG_URL = 'https://public-data.geolonia.com/yaizu-city/flood_l2_shinsuishin/{z}/{x}/{y}.png';

export const MAIN_MAP_ID = 'main-map';
export const SECOND_MAP_ID = 'second-map';
